<template>
  <div class="fill-height">


    <v-card class="fill-height">

      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
          اطلاعات مهمانان
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>


      <v-card-text>
        <v-row>
          <v-col  cols="12" md="1" sm="12">
            <v-btn class="float-right "
                   color="primary"
                   right
                   fab
                   small
                   @click="forNew()"
            >
              <v-icon>fa fa-plus</v-icon>
            </v-btn>
          </v-col>

        </v-row>
        <v-row>
          <v-col
              cols="12"
              sm="12"
              md="4">
            <v-autocomplete
                :items="buildingItems"
                v-model="model.buildingId"
                @input="handleInput"
                dense
                outlined
                @change="getUnitList"
                :error-messages="getError('buildingId')"
                auto-select-first  append-icon="fas fa-angle-down"
                label="انتخاب مجتمع"
            />
          </v-col>
          <v-col
              cols="12"
              sm="12"
              md="4">
            <v-autocomplete
                :items="unitList"
                v-model="unitId"
                @input="handleInput"
                @change="search"
                dense
                outlined
                :error-messages="getError('unitId')"
                auto-select-first  append-icon="fas fa-angle-down"
                label="انتخاب واحد"

            />
          </v-col>
          <v-col cols="12" md="4" sm="12">
            <v-text-field
                outlined
                dense
                v-model="name" label="نام شخص"/>
          </v-col>
          <v-col cols="12" md="4" sm="12">
            <v-text-field
                outlined
                dense
                v-model="mobile" label="تلفن همراه"/>
          </v-col>
          <v-col cols="12" md="4" sm="12" class="d-inline-flex">


            <v-text-field
                outlined
                dense
                id="part1"
                placeholder="555"
                @keyup="keyPressPart1"
                v-model="part1" />

            <v-autocomplete
                :items="letterList"
                v-model="part2"
                @input="handleInput"
                dense
                placeholder="الف"
                id="part2"
                @change="keyPressPart2"
                outlined
                auto-select-first  append-icon="fas fa-angle-down"
            />

            <v-text-field
                outlined
                dense
                placeholder="55"
                id="part3"
                @keyup.self="keyPressPart3"
                v-model="part3" />

            <v-text-field
                outlined
                dense
                id="part4"
                @keyup="keyPressPart4"
                v-model="part4" placeholder="22"/>
          </v-col>
          <v-col
              cols="12"
              sm="12"
              md="4"
          class="d-inline-flex">
            <date-picker placeholder="تاریخ ورود " v-model="model.dateStr" type="date" color="#3b5694" clearable
                         auto-submit> </date-picker>
            <span style="color: red" v-if="getError('dateStr')" v-text="getError('dateStr')"/>
            <date-picker placeholder="زمان ورود " v-model="model.timeStr" type="time" color="#3b5694" clearable
                         auto-submit>
            </date-picker>
            <span style="color: red" v-if="getError('timeStr')" v-text="getError('timeStr')"/>
          </v-col>

<!--        </v-row>-->
<!--<v-row>-->
  <v-col  cols="12" md="4" sm="12">
    <v-btn
        block
        depressed
        color="primary"
        class=" p-1 m-1"
        @click="save"
        :loading="loading"
    >
      ثبت
    </v-btn>
  </v-col>
  <v-col cols="12"
         sm="12"
         md="8" class="d-inline-block">
    <b-pagination
        v-model="skip"
        :total-rows="paging.totalSize"
        :per-page=take
        first-text="اولین"
        prev-text="<"
        next-text=">"
        ellipsis-text="..."
        last-text="آخرین"
        dir="ltr"
        limit="5"
        @change="pageChangeHandler"
    />

  </v-col>
</v-row>
        <v-card-text>
          <b-table
              v-if="can('establishmentList')"
              :items="dataItems"
              :fields="columns"
              :current-page="skip"
              :per-page=0
              stacked="md"
              show-empty
              responsive striped
          >
            <template #cell(actions)="row">
              <v-btn depressed class="mr-1" v-if="can('editGuest')" small color="primary" @click="forEdit(row.item)">
                ویرایش
              </v-btn>
              <v-btn depressed class="mr-1" v-if="can('deleteGuest')" small color="error" @click="remove(row.item)">
                حذف
              </v-btn>
              <v-btn depressed class="mr-1" v-if="can('editGuest')" small color="success" @click="forSelect(row.item)">
                انتخاب
              </v-btn>
            </template>

          </b-table>

        </v-card-text>


      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Guest_se from "./Guest_se";
import {mapMutations} from "vuex";

export default {
  name: 'Guest',
  data() {
    return {
      modelId: '',
      part1: '',
      part2: '',
      part3: '',
      part4: '',
      mobile: '',
      name: '',
      unitId: '',
      loading: false,
      searchvalue: '',
      model:{},
      model2:{},
      data: {},
      dataItems: [],
      unitList: [],
      buildingItems: [],
      bindingErrors: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      letterList:[
          {text:'الف',value:'الف'},{text:'ب',value:'ب'},{text:'پ',value:'پ'},{text:'ت',value:'ت'},{text:'ث',value:'ث'},{text:'ح',value:'ح'},{text:'ج',value:'ج'},
          {text:'چ',value:'چ'},{text:'خ',value:'خ'},{text:'د',value:'د'},{text:'ذ',value:'ذ'},{text:'ر',value:'ر'},{text:'ز',value:'ز'},
          {text:'ژ',value:'ژ'},{text:'س',value:'س'},{text:'ش',value:'ش'},{text:'ص',value:'ص'},{text:'ض',value:'ض'},{text:'ط',value:'ط'},
          {text:'ظ',value:'ظ'},{text:'ع',value:'ع'},{text:'غ',value:'غ'},{text:'ف',value:'ف'},{text:'ق',value:'ق'},{text:'ک',value:'ک'},
          {text:'گ',value:'گ'},{text:'ل',value:'ل'},{text:'م',value:'م'},{text:'ن',value:'ن'},{text:'و',value:'و'},{text:'ه',value:'ه'},{text:'ی',value:'ی'},
      ],
      columns: [
        {key: 'unit.building.name', label: 'مجتمع', sortable: true, sortDirection: 'desc'},
        {key: 'unit.unitName', label: 'نام واحد', sortable: true, sortDirection: 'desc'},
        {key: 'personName', label: 'نام شخص', sortable: true, sortDirection: 'desc'},
        {key: 'mobile', label: 'شماره موبایل', sortable: true, sortDirection: 'desc'},
        {key: 'plaque', label: 'پلاک خودرو', sortable: true, sortDirection: 'desc'},
        {key: 'actions', label: 'عملیات'}
      ],

    };

  },

  mounted() {
    this.$root.$on('Guest', () => {
      this.fillDataItems()
    })

  },

  methods: {
    close(){
      this.searchvalue=""
      this.dataItems=[]
      this.unitList=[]
      this.part1=''
      this.part2=''
      this.part3=''
      this.part4=''
      this.name=''
      this.mobile=''
      this.$root.$emit('Guest')
      this.$router.push('/home')
    },
    savaAndClose(){
      this.searchvalue=""
      this.dataItems=[]
      this.unitList=[]
      this.part1=''
      this.part2=''
      this.part3=''
      this.part4=''
      this.name=''
      this.mobile=''
      this.$root.$emit('Guest')
      this.$router.push('/guest')
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),

    save(){
      this.model.part1=this.part1
      this.model.part2=this.part2
      this.model.part3=this.part3
      this.model.part4=this.part4
      this.model.mobile=this.mobile
      this.model.personName=this.name
      this.model.unitId=this.unitId

      this.loading=true
      Guest_se.save(this.model).then(response => {
        this.loading=false
        if (response && response.status === 200) {
          this.$snack({type: 'success'})
       this.savaAndClose()
        }else if (response && response.response.status === 400) {
          this.loading=false
          this.bindingErrors = response.response.data;
        }
      })
    },
    fetch() {
      Guest_se.getById(this.modelId).then(response => {
        this.model = response.data.model
        this.part1=this.model.part1
        this.part2=this.model.part2
        this.part3=this.model.part3
        this.part4=this.model.part4
        this.name=this.model.personName
        this.mobile=this.model.mobile
        this.unitId=this.model.unitId
        if (this.model.id){
          this.getUnitList(this.model.buildingId)
        }
        this.unitList = response.data.unitList
      })
    },

    forNew: function () {
      this.model = {};
      this.modelId = '';
      this.fillDataItems()
      // this.fetch()
    },
 forEdit: function (e) {
      this.modelId = e.id;
      this.fetch()
    },
forSelect: function (e) {
      Guest_se.selectGuest(e.id).then(response=>{
        this.model = response.data.model
        this.part1=this.model.part1
        this.part2=this.model.part2
        this.part3=this.model.part3
        this.part4=this.model.part4
        this.name=this.model.personName
        this.mobile=this.model.mobile
        this.unitId=this.model.unitId
        if (this.model.buildingId){
          this.getUnitList(this.model.buildingId)
        }
        this.unitList = response.data.unitList
      })
    },

    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              Guest_se.delete(e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems()
                } else {
                  this.$snack({type: 'error'})
                }
              })
          )
    },

    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems();

    },


    fillDataItems() {
      Guest_se.getPage(this.skip - 1, this.take).then(response => {
        this.paging =  response.data.page
          this.model =  response.data.model
          this.dataItems =  response.data.guestList
          this.buildingItems =  response.data.buildingItems
           this.keyPressPart1()
           this.keyPressPart2()
           this.keyPressPart3()
           this.keyPressPart4()
      });
    },
    keyPressPart1(){
      if(this.part1.length>2){
        this.search()
        document.getElementById('part2').focus();
      }
    },
    keyPressPart2(){
      if(this.part2.length!==''){
        document.getElementById('part3').focus();
        this.search()
      }


    },
    keyPressPart3(){
        if(this.part3.length>1){
        this.search()
        document.getElementById('part4').focus();
      }
      if(this.part4.length>1){
        this.search()
      }
    },
    keyPressPart4(){
      if(this.part4.length>1){
        this.search()
      }
    },
    search(){
     Guest_se.search(this.part1
      ,this.part2,this.part3,this.part4,this.unitId,this.skip-1, this.take).then(response=> {

    if (response.data.check) {
    this.paging = response.data.page
    }
    this.dataItems = response.data.guestList
    this.model2 = response.data.model
  })
    },
    handleInput (value) {
      this.$emit('input', value)
    },

    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find( ({ fieldName }) => fieldName === key );
        if(error && error.message ) return  error.message[0]
      }
      return ''
    },

    getUnitList(){
      Guest_se.getUnits(this.model.buildingId).then(response=>{
          this.unitList=response.data.unitList
      })
    },


  },

  created() {
    this.setDrawer(false)
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
